import clientApi from '../../api/client'
import locationApi from '../../api/location'
import profileApi from '../../api/profile'
import moment from 'moment'

// initial state
const state = {
  clients: [],
  detailedClient: '',
}

const getters = {
}

const actions = {
  getAll ({ commit }, userId) {
    return clientApi.getAll(userId, clients => {
      commit('setClients', clients)
    })
  },

  getAllPromisized ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      clientBusinessApi.getAll(userId, clientBusinesses => {
        commit('setClientBusinesses', clientBusinesses)
        resolve(clientBusinesses)
      },
      error => {
        reject(error)
      })
    })
  },


  updateOwnProfile ({ commit }, params) {
    return new Promise((resolve, reject) => {
      profileApi.clientUpdate(params, profile => {
        resolve(profile)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  sendPasswordReset ({ commit }, cilentId) {
    return new Promise((resolve, reject) => {
      passwordApi.sendReset(clientId, message => {
        resolve()
      },
      error => {
        reject()
      })
    })
  },

  getClient ({ commit }, clientId) {
    return new Promise((resolve, reject) => {
      clientApi.get(clientId, client => {
        commit('setDetailedClient', client)
        resolve()
      },
      error => {
        console.log('couldnt get that client')
        reject()
      })
    })
  },

  deactivate ({ commit }, clientId) {
    return new Promise((resolve, reject) => {
      clientApi.deactivate(clientId, client => {
        commit('setDetailedClient', client)
        resolve(client)
      },
      error => {
        console.log('couldnt deactivate that client')
        reject(error)
      })
    })
  },

  reactivate ({ commit }, clientId) {
    return new Promise((resolve, reject) => {
      clientApi.reactivate(clientId, client => {
        commit('setDetailedClient', client)
        resolve(client)
      },
      error => {
        console.log('couldnt reactivate that client')
        reject(error)
      })
    })
  },

  delete ({ commit }, clientId) {
    return new Promise((resolve, reject) => {
      clientApi.delete(clientId, response => {
        resolve()
      },
      error => {
        console.log('couldnt delete that client')
        reject(error)
      })
    })
  },

  create ({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      clientApi.create(idFieldData, client => {
        commit('updateClient', client)
        commit('setDetailedClient', client)
        resolve(client)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  update ({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      clientApi.update(idFieldData, client => {
        commit('updateClient', client)
        commit('setDetailedClient', client)
        resolve(client)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  addLocation ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      clientApi.addLocation(params, r => {
        resolve(r)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  addAdminLocation ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      clientApi.addAdminLocation(params, r => {
        resolve(r)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  removeLocation ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      clientApi.deleteLocation(params, r => {
        resolve(r)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  removeAdminLocation ({ dispatch, commit }, params) {
    return new Promise((resolve, reject) => {
      clientApi.deleteAdminLocation(params, r => {
        resolve(r)
      },
      error => {
        console.log('Something broke at the API');
        reject(error)
      })
    })
  },

  locationUpdate ({ dispatch, commit }, idFieldData) {
    return new Promise((resolve, reject) => {
      locationApi.update(idFieldData, location => {
        resolve(location)
      },
      error => {
        console.log('Something broke at the API');
        reject()
      })
    })
  },

  refreshDetailedClient  ({ dispatch, commit }, client) {
    commit('setDetailedClient', client)
  },

  refreshLocation ({ dispatch, commit }, location) {
    commit('refreshLocation', location)
  }

}

const mutations = {
  setClients (state, clients) {
    state.clients = clients
    //state.available = Object.assign({}, state.available, shifts) // Works...
    //Object.assign(state.available, shifts) // NO! doesn't work!
  },

  setDetailedClient (state, client) {
    state.detailedClient = client
  },

  updateClient (state, client) {
    state.clients = [
      ...state.clients.filter(c => c.id !== client.id),
      client
    ]
  },

  refreshLocation (state, location) {
    state.detailedClient.locations = [
      ...state.detailedClient.locations.filter(l => l.id !== location.id),
      location
    ]
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
